/**
 * WORLD module — procedural noir street block + office interior.
 * Owns all static geometry, canvas textures, clue prop placement, and the
 * five named cinematic shots. See CONTRACTS.md (WORLD section).
 */
import { Group } from 'three'
import type { ModuleContext } from '../core/types'
import { FAN_SPEED_RAD_PER_S } from './constants'
import { buildClues } from './clues'
import { buildNeonSign } from './neon'
import { buildOffice } from './office'
import { buildProps } from './props'
import { registerShots } from './shots'
import { buildStreet } from './street'

const TWO_PI = Math.PI * 2

export const initWorld = (ctx: ModuleContext): void => {
  const world = new Group()
  world.name = 'world'

  world.add(buildStreet())
  const neonSign = buildNeonSign()
  world.add(neonSign.group)
  world.add(buildProps())

  const office = buildOffice()
  world.add(office.group)

  const clues = buildClues(ctx.bus)
  world.add(clues.group)

  ctx.loop.onUpdate((dt) => {
    office.fanRotor.rotation.y = (office.fanRotor.rotation.y + FAN_SPEED_RAD_PER_S * dt) % TWO_PI
    neonSign.update(dt)
    clues.update(dt)
  })

  // Rain is owned by LIGHT (light-reactive streaks); WORLD's duplicate
  // particle rain was removed at integration to avoid double weather.

  ctx.scene.add(world)
  registerShots(ctx.debug)
}
